module.exports = __webpack_public_path__ + "static/img/img_cabinet.45493be4.png";